import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const articles = latestArticles.slice(0, 6);

  return (
    <section className="py-16 md:py-20" aria-labelledby="latest-title">
      <div className="w-full px-6 md:px-10">
        <h2 id="latest-title" className="text-3xl md:text-5xl font-black text-foreground-950 mb-2">
          最新吃瓜 🔥 每日大赛
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10">
          实时更新最新爆料，每天都有新瓜等你来吃
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group cursor-pointer rounded-lg overflow-hidden relative h-[380px] md:h-[420px] ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-500/80 text-white text-xs font-medium mb-3 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="text-base md:text-lg font-bold text-white leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-white/50 line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center gap-3 text-xs text-white/40">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatNumber(article.views)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function formatNumber(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return String(n);
}